module.exports = __webpack_public_path__ + "img/901059991.165d6fe7.png";